import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Logs } from './logs.entity';
import { LogsService } from './logs.service';
import { LogsController } from './logs.controller';
import { LogsAdapter } from './dto/logs.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: [
    TypeOrmModule.forFeature([Logs]),
    // forwardRef(() => ClusterModule),
  ],
  // controllers: [StatesController],
  providers: [LogsService,LogsAdapter,ApplicationExceptionHandler],
  exports: [LogsService],
  controllers: [LogsController],
})
export class LogsModule {}
